import type { Currency } from '@/bindings/Currency'
import registry from '@/bindings/currencies.json'
import type { Language } from '@/bindings/Language'

/** Code → ISO 4217 minor units; `romi_domain::currency` exports it with the bindings (B4). */
const MINOR_UNITS: Readonly<Record<string, number>> = registry

export const CURRENCIES = Object.keys(MINOR_UNITS) as readonly Currency[]
export const DEFAULT_CURRENCY: Currency = 'VND'

/** Decimal places a stored amount may carry; 0 for a code the registry lacks. */
export function minorUnits(currency: Currency): number {
  return MINOR_UNITS[currency] ?? 0
}

/** Mirrors `romi_domain::menu::max_price_decimals`: the strictest currency wins; registry max when none. */
export function maxPriceDecimals(currencies: readonly Currency[]): number {
  if (currencies.length === 0) return Math.max(...CURRENCIES.map(minorUnits))
  return Math.min(...currencies.map(minorUnits))
}

/** The currency's name in the UI language, or the code when the runtime has no name for it. */
export function currencyName(currency: Currency, language: Language): string {
  try {
    const name = new Intl.DisplayNames([language], { type: 'currency' }).of(currency)
    return name && name !== currency ? name : currency
  } catch {
    return currency
  }
}
